






import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { FixedPhraseRootReference } from "../../../domain/document";
import { FixedLoading } from "../../system";
import FixedPhraseTreeSelector from "./FixedPhraseTreeSelector.vue";
import { FixedPhraseTreeSelectorMixin } from "./mixins";
import { IEditFixedPhrase } from "./IEditFixedPhrase";
import { FixedPhraseTreeViewerMixin } from "../../workflow/editors/controls/fixedPhrase/mixins";
import { FixedPhraseKinds } from "./FixedPhraseKinds";

@Component({
  components: {
    FixedLoading,
    selector: FixedPhraseTreeSelector,
  }
})
export default class TemporarySaveUserFixedPhraseSelector extends Mixins(
  FixedPhraseTreeSelectorMixin,
  FixedPhraseTreeViewerMixin,
) implements IEditFixedPhrase {
  @Prop()
  userId: string;

  created(): void {
    this.loadDirectories();
  }

  private loadDirectories(): void {
    this.getFixedPhrase(FixedPhraseKinds.TemporarySaveUser, this.userId)
    .then(d => this.rootFixedPhrase = d)
    .catch(e => {
      this.rootFixedPhrase = new FixedPhraseRootReference(null, null, []);
      this.$error(
        this.$wording.document.note + "定型文取得失敗",
        this.$wording.document.note + "定型文を読み込めませんでした。",
        e);
    });
  }

  mounted(): void {
    this.selector = this.$refs.selector;
    window.addEventListener("message", this.onWindowNotify, false);
  }

  destroyed(): void {
    window.removeEventListener("message", this.onWindowNotify, false);
  }

  private onWindowNotify(event: any): void {
    try {
      const message = JSON.parse(event.data);
      if (message.key === "userFixedPhraseUpdated") {
        this.loadDirectories();
      }
    } catch {}
  }

  @Emit("doubleClicked")
  doubleClicked(): void {}

  dragStart(event: DragEvent, text: string): void {
    event.dataTransfer.effectAllowed = "copy";
    event.dataTransfer.setData("text", text);
  }

  async editFixedPhrase(): Promise<void> {
    if (!this.isLoaded) {
      return;
    }
    const latest = await this.getFixedPhrase(FixedPhraseKinds.TemporarySaveUser, this.userId);
    const result = await this.getEditedFixedPhrase(latest, FixedPhraseKinds.TemporarySaveUser, this.userId);
    if (result == null) { return; }
    await this.setFixedPhrase(FixedPhraseKinds.TemporarySaveUser, result, () => this.notifyMessage("userFixedPhraseUpdated"));
  }
}
